export default "__VITE_ASSET__Cko2RuuU__"